import React, { useCallback, useState, FC } from 'react';
import { useIntl } from 'react-intl';
import InputRequireLogin from '../Auth';
import { useUserMe } from '../../../../../hooks/api/me';
import { useResendVerificationMail } from '../../../../../hooks/api/sendVerification';
import { SchemeType } from '../../../../../interfaces/merchants/products/purchases';
import { LoadingIconWithReloadButton } from '../../../../../molecules/common/LoadingIconWithReloadButton';
import EmailVerification, {
  VerificationContext,
} from '../../../../../molecules/common/EmailVerification';

type Props = {
  postable: boolean;
  moveToNext: () => void;
  onSubmitSubscribed?: () => void;
  schemeType: SchemeType;
  isEmailVerified: boolean;
  isLoggedIn: boolean;
};

const ProductPurchaseAuth: FC<Props> = ({
  postable,
  moveToNext,
  onSubmitSubscribed,
  schemeType,
  isEmailVerified,
  isLoggedIn,
}) => {
  const intl = useIntl();
  const [isJustCreateUser, setIsJustCreateUser] = useState(false);
  const { meResponseData: loginUser } = useUserMe();
  const { isValidating, resendVerificationMail } = useResendVerificationMail();

  const onJustCreateUser = useCallback(() => {
    setIsJustCreateUser(true);
  }, []);

  const onRequestResendEmail = useCallback(async () => {
    const res = await resendVerificationMail();
    if (res.success) {
      const message = intl.formatMessage({
        id: 'reservationFlowAuthPage.successResendEmail',
      });
      alert(message);
    } else {
      const message = intl.formatMessage({
        id: 'reservationFlowAuthPage.failedResendEmail',
      });
      alert(message);
    }
  }, [resendVerificationMail, intl]);

  if (!isLoggedIn)
    return (
      <InputRequireLogin
        postable={postable}
        onSubmit={moveToNext}
        schemeType={schemeType}
        onSubmitSubscribed={onSubmitSubscribed}
        isEmailVerified={isEmailVerified}
        onJustCreateUser={onJustCreateUser}
      />
    );

  if (loginUser && !isEmailVerified) {
    return (
      <EmailVerification
        isJustCreateUser={isJustCreateUser}
        email={loginUser.email}
        isValidating={isValidating}
        handleSubmit={onRequestResendEmail}
        verificationContext={VerificationContext.PRODUCT}
      />
    );
  }

  return <LoadingIconWithReloadButton />;
};

export default ProductPurchaseAuth;
